"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultOutput = exports.SubmissionResults = exports.FeedbackCategory = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var FeedbackCategory;
(function (FeedbackCategory) {
    FeedbackCategory["normal"] = "normal";
    FeedbackCategory["past_limit_submission"] = "past_limit_submission";
    FeedbackCategory["ultimate_submission"] = "ultimate_submission";
    FeedbackCategory["staff_viewer"] = "staff_viewer";
    FeedbackCategory["max"] = "max";
})(FeedbackCategory = exports.FeedbackCategory || (exports.FeedbackCategory = {}));
// tslint:disable-next-line: no-namespace
var SubmissionResults;
(function (SubmissionResults) {
    function get_all_ultimate_submission_results(project_pk, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.include_staff, include_staff = _c === void 0 ? true : _c, _d = _b.page_num, page_num = _d === void 0 ? 1 : _d, _e = _b.page_size, page_size = _e === void 0 ? 100 : _e;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("projects/" + project_pk + "/all_ultimate_submission_results/"
                            + ("?page=" + page_num + "&groups_per_page=" + page_size)
                            + ("&full_results=true&include_staff=" + include_staff))];
                    case 1:
                        response = _f.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    SubmissionResults.get_all_ultimate_submission_results = get_all_ultimate_submission_results;
    function get_all_minimal_ultimate_submission_results(project_pk, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.include_staff, include_staff = _c === void 0 ? true : _c, _d = _b.page_num, page_num = _d === void 0 ? 1 : _d, _e = _b.page_size, page_size = _e === void 0 ? 100 : _e;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("projects/" + project_pk + "/all_ultimate_submission_results/"
                            + ("?page=" + page_num + "&groups_per_page=" + page_size)
                            + ("&full_results=false&include_staff=" + include_staff))];
                    case 1:
                        response = _f.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    SubmissionResults.get_all_minimal_ultimate_submission_results = get_all_minimal_ultimate_submission_results;
    function get_submission_result(submission_pk, feedback_category) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + submission_pk + "/results/?feedback_category=" + feedback_category)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    SubmissionResults.get_submission_result = get_submission_result;
})(SubmissionResults = exports.SubmissionResults || (exports.SubmissionResults = {}));
// tslint:disable-next-line: no-namespace
var ResultOutput;
(function (ResultOutput) {
    function get_ag_test_cmd_result_output_size(submission_pk, ag_test_cmd_result_pk, feedback_category) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + submission_pk + "/ag_test_cmd_results/"
                            + (ag_test_cmd_result_pk + "/output_size/")
                            + ("?feedback_category=" + feedback_category))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    ResultOutput.get_ag_test_cmd_result_output_size = get_ag_test_cmd_result_output_size;
    function get_ag_test_cmd_result_stdout(submission_pk, ag_test_cmd_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/ag_test_cmd_results/" + ag_test_cmd_result_pk + "/stdout/"
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_ag_test_cmd_result_stdout = get_ag_test_cmd_result_stdout;
    function get_ag_test_cmd_result_stderr(submission_pk, ag_test_cmd_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/ag_test_cmd_results/" + ag_test_cmd_result_pk + "/stderr/"
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_ag_test_cmd_result_stderr = get_ag_test_cmd_result_stderr;
    function get_ag_test_cmd_result_stdout_diff(submission_pk, ag_test_cmd_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + submission_pk + "/ag_test_cmd_results/"
                            + (ag_test_cmd_result_pk + "/stdout_diff/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    ResultOutput.get_ag_test_cmd_result_stdout_diff = get_ag_test_cmd_result_stdout_diff;
    function get_ag_test_cmd_result_stderr_diff(submission_pk, ag_test_cmd_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + submission_pk + "/ag_test_cmd_results/"
                            + (ag_test_cmd_result_pk + "/stderr_diff/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    ResultOutput.get_ag_test_cmd_result_stderr_diff = get_ag_test_cmd_result_stderr_diff;
    function get_ag_test_suite_result_output_size(submission_pk, ag_test_suite_result_pk, feedback_category) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + submission_pk + "/ag_test_suite_results/"
                            + (ag_test_suite_result_pk + "/output_size/")
                            + ("?feedback_category=" + feedback_category))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    ResultOutput.get_ag_test_suite_result_output_size = get_ag_test_suite_result_output_size;
    function get_ag_test_suite_result_setup_stdout(submission_pk, ag_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/ag_test_suite_results/" + ag_test_suite_result_pk + "/stdout/"
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_ag_test_suite_result_setup_stdout = get_ag_test_suite_result_setup_stdout;
    function get_ag_test_suite_result_setup_stderr(submission_pk, ag_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/ag_test_suite_results/" + ag_test_suite_result_pk + "/stderr/"
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_ag_test_suite_result_setup_stderr = get_ag_test_suite_result_setup_stderr;
    function get_mutation_test_suite_result_output_size(submission_pk, mutation_test_suite_result_pk, feedback_category) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/output_size/")
                            + ("?feedback_category=" + feedback_category))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_output_size = get_mutation_test_suite_result_output_size;
    function get_mutation_test_suite_result_setup_stdout(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/setup_stdout/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_setup_stdout = get_mutation_test_suite_result_setup_stdout;
    function get_mutation_test_suite_result_setup_stderr(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/setup_stderr/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_setup_stderr = get_mutation_test_suite_result_setup_stderr;
    function get_mutation_test_suite_result_get_student_test_names_stdout(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/get_student_test_names_stdout/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_get_student_test_names_stdout = get_mutation_test_suite_result_get_student_test_names_stdout;
    function get_mutation_test_suite_result_get_student_test_names_stderr(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/get_student_test_names_stderr/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_get_student_test_names_stderr = get_mutation_test_suite_result_get_student_test_names_stderr;
    function get_mutation_test_suite_result_validity_check_stdout(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/validity_check_stdout/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_validity_check_stdout = get_mutation_test_suite_result_validity_check_stdout;
    function get_mutation_test_suite_result_validity_check_stderr(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/validity_check_stderr/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_validity_check_stderr = get_mutation_test_suite_result_validity_check_stderr;
    function get_mutation_test_suite_result_grade_buggy_impls_stdout(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/grade_buggy_impls_stdout/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_grade_buggy_impls_stdout = get_mutation_test_suite_result_grade_buggy_impls_stdout;
    function get_mutation_test_suite_result_grade_buggy_impls_stderr(submission_pk, mutation_test_suite_result_pk, feedback_category, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + submission_pk + "/mutation_test_suite_results/"
                            + (mutation_test_suite_result_pk + "/grade_buggy_impls_stderr/")
                            + ("?feedback_category=" + feedback_category), { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    }
    ResultOutput.get_mutation_test_suite_result_grade_buggy_impls_stderr = get_mutation_test_suite_result_grade_buggy_impls_stderr;
})(ResultOutput = exports.ResultOutput || (exports.ResultOutput = {}));
//# sourceMappingURL=submission_result.js.map